import {initInputBody} from "../../../../default/global/js/inputfile";

export function initCustomization(customizeModal) {
    addNewCustomization(customizeModal);
    initDeleteCustomization(customizeModal);
    updateDeleteButtons(customizeModal);
    initCustomizationValidation(customizeModal);
    initCustomizationTabErrorClear(customizeModal);
}

export function checkValidDLRGCustomization(form) {
    let isValid = true;
    for (const variants of form.querySelectorAll(".variantTab")) {
        const errorEl = variants.querySelector('.customizationErrorMessage');

        const variantSelect = variants.querySelector('select[name^="inputcustomize_variant"]');
        const variantMissing = variantSelect && !variantSelect.value;

        const hasRequiredFieldEmpty = [...variants.querySelectorAll('input[type="text"]')]
            .some(function(f) { return f.name.includes('inputcustomize_') && f.required && f.value.trim() === ''; });

        let errorMsg = '';
        if (variantMissing) {
            errorMsg = GLOBALS.tc.customization_variant_required || '';
        } else if (hasRequiredFieldEmpty) {
            errorMsg = GLOBALS.tc.customization_field_required || '';
        }

        let requiredFieldsMissing = false;
        for (const field of variants.querySelectorAll("input,select,textarea")) {
            if (field.required && !field.value) {
                requiredFieldsMissing = true;
                const labelEl = variants.querySelector('label[for="' + field.id + '"]');
                let fieldLabel = field.name;
                if (labelEl) {
                    const clone = labelEl.cloneNode(true);
                    clone.querySelectorAll('span').forEach(function(s) { s.remove(); });
                    fieldLabel = clone.textContent.trim() || field.name;
                }
                errorMsg = (GLOBALS.tc.customization_error_field_required || '').replace('%s', fieldLabel);
                break;
            }
        }

        const tabInvalid = variantMissing || hasRequiredFieldEmpty || requiredFieldsMissing;
        variants.classList.toggle('is-invalid', tabInvalid);
        if (errorEl) {
            errorEl.textContent = errorMsg;
            errorEl.hidden = !tabInvalid;
        }

        if (tabInvalid) {
            isValid = false;
        }
    }

    return isValid;
}

export function validateCustomizationTabs(form) {
    const variantTabs = form.querySelectorAll('.variantTab');
    let allValid = true;
    variantTabs.forEach(tab => {
        const filled = [...tab.querySelectorAll('input,textarea')].some(field => {
            return /^inputcustomize_\d+_\d+$/.test(field.name) && field.value.trim() !== '';
        });
        tab.classList.toggle('is-invalid', !filled);
        const errorEl = tab.querySelector('.customizationErrorMessage');
        if (errorEl) {
            errorEl.textContent = filled ? '' : (GLOBALS.tc.customization_field_required || '');
            errorEl.hidden = filled;
        }
        allValid = allValid && filled;
    });
    return allValid;
}

function replaceVariantIndex(str, newIndex) {
    return str
        .replace(/inputcustomize_\d+_(\d+)/g, `inputcustomize_${newIndex}_$1`)
        .replace(/inputcustomize_qty\[\d+\]/g, `inputcustomize_qty[${newIndex}]`)
        .replace(/inputcustomize_variant\[\d+\]/g, `inputcustomize_variant[${newIndex}]`)
        .replace(/js-quantity-value(?:-\d+)?/g, `js-quantity-value-${newIndex}`);
}

function addNewCustomization(customizeModal) {
    const button = customizeModal.querySelector('#addNewCustomization');
    if (!button) return;

    button.addEventListener('click', function (e) {
        e.preventDefault();

        const row = button.closest('.row');
        const variantTabs = row.querySelectorAll('.variantTab');
        const newIndex = variantTabs.length + 1;

        const newTab = variantTabs[0].cloneNode(true);

        newTab.querySelectorAll('[id]').forEach(el => {
            el.id = replaceVariantIndex(el.id, newIndex);
        });

        newTab.querySelectorAll('[name]').forEach(el => {
            el.name = replaceVariantIndex(el.name, newIndex);
        });

        newTab.querySelectorAll('label[for]').forEach(el => {
            el.htmlFor = replaceVariantIndex(el.htmlFor, newIndex);
        });

        newTab.querySelectorAll('[aria-labelledby]').forEach(el => {
            el.setAttribute('aria-labelledby', replaceVariantIndex(el.getAttribute('aria-labelledby'), newIndex));
        });

        newTab.querySelectorAll('input').forEach(el => {
            if (el.type !== 'hidden' && !/^inputcustomize_qty/.test(el.name)) el.value = '';
        });

        newTab.querySelectorAll('textarea').forEach(el => {
            el.value = '';
        });

        newTab.querySelectorAll('.infieldInputGroup.is-filled').forEach(el => {
            el.classList.remove('is-filled');
        });

        const footer = row.querySelector('.customizationFooter');
        row.insertBefore(newTab, footer);

        const fileInputs = newTab.querySelectorAll('.fileBody');
        if (fileInputs.length > 0) {
            initInputBody(fileInputs);
        }

        const deleteBtn = newTab.querySelector('.deleteCustomization');
        if (deleteBtn) {
            deleteBtn.addEventListener('click', onDeleteClick);
        }

        updateDeleteButtons(row);
    });
}

function initCustomizationValidation(customizeModal) {
    const form = customizeModal.querySelector('#form_queue');
    if (!form) return;
    form.addEventListener('submit', function (e) {
        if (!validateCustomizationTabs(form)) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }, true);
}

function initDeleteCustomization(customizeModal) {
    customizeModal.querySelectorAll('.deleteCustomization').forEach(btn => {
        btn.addEventListener('click', onDeleteClick);
    });
}

function onDeleteClick(e) {
    e.preventDefault();
    const tab = this.closest('.variantTab');
    const row = tab.closest('.row');
    const variantTabs = row.querySelectorAll('.variantTab');
    if (variantTabs.length <= 1) return;
    tab.remove();
    updateDeleteButtons(row);
}

function initCustomizationTabErrorClear(customizeModal) {
    customizeModal.addEventListener('input', function(e) {
        const field = e.target;
        if (!field.matches('input, textarea, select')) return;
        const tab = field.closest('.variantTab');
        if (!tab || !tab.classList.contains('is-invalid')) return;

        tab.classList.remove('is-invalid');
        const errorEl = tab.querySelector('.customizationErrorMessage');
        if (errorEl) {
            errorEl.textContent = '';
            errorEl.hidden = true;
        }
    });
}

function updateDeleteButtons(container) {
    const row = container.classList.contains('row') ? container : container.querySelector('.row');
    if (!row) return;
    const variantTabs = row.querySelectorAll('.variantTab');
    const showDelete = variantTabs.length > 1;
    variantTabs.forEach(tab => {
        const btn = tab.querySelector('.deleteCustomization');
        if (btn) btn.style.display = showDelete ? '' : 'none';
    });
}
